'use client'

import React from 'react'
import Link from 'next/link'
import { track } from '@/utils/analytics'

// Contextual routes to the reading-plan tool or ingredient-name checker.
export interface RiskQuizInlineNudgeProps {
  /** Stable per-mount label — eg `blog_inline_kcups`, `blog_inline_stanley`.
   *  Lets GA4 attribute risk-checker traffic back to the source article. */
  source: string
  /** Optional copy override. Default fits any blog post; override for special
   *  cases (eg the cosmetics ingredient checker rather than risk checker). */
  text?: string
  /** Optional link text override (default: "Build a product-routine reading plan"). */
  linkText?: string
  /** Optional destination override (default: /risk-checker). */
  href?: string
}

export default function RiskQuizInlineNudge({
  source,
  text = 'Want a source question for your routine?',
  linkText = 'Build a product-routine reading plan',
  href = '/risk-checker',
}: RiskQuizInlineNudgeProps) {
  return (
    <aside
      className="not-prose my-6 px-4 py-3 text-sm text-gray-700 bg-[#1E6B47]/8 border-l-2 border-[#1E6B47] rounded-r-lg leading-relaxed"
      aria-label={href === '/microplastic-ingredient-checker' ? 'Review an ingredient list' : 'Build a product-routine reading plan'}
    >
      <span aria-hidden="true" className="text-[#1E6B47] font-semibold">→ </span>
      {text}{' '}
      <Link
        href={href}
        onClick={() =>
          track('topic_hub_click', {
            source,
            destination: href,
            page_type: 'blog',
          })
        }
        className="font-semibold text-[#1E6B47] underline hover:text-[#155235]"
      >
        {linkText}
      </Link>{' '}
      {href === '/microplastic-ingredient-checker' ? 'to review declared ingredient names and their limitations.' : 'to choose product questions and relevant guides.'}
    </aside>
  )
}
